import React, { useCallback, useEffect, useState } from 'react';
import StatelessAvatar from '../../../base/avatar/components/web/StatelessAvatar';
import { getAvatarColor, getInitials } from '../../../base/avatar/functions';
/**
 * The SI's photo, else its initials, the way every participant tile in the meeting is drawn.
 *
 * @returns {ReactElement}
 */
export default function SiFace({ name, url, size }) {
    const [broken, setBroken] = useState(false);
    const initials = getInitials(name);
    const onError = useCallback(() => setBroken(true), []);
    useEffect(() => setBroken(false), [url]);
    return (React.createElement(StatelessAvatar, { color: getAvatarColor(initials, []), initials: initials, onAvatarLoadError: onError, size: size, url: !broken && url ? url : undefined }));
}
